module.exports = __webpack_public_path__ + "static/ux_2_2_eg-b1af873a5f2abce26bebf84649400928.png";